import Swal from 'sweetalert2';
import { api_url } from './global_string';

function data_change_status(status, row, detail) {
  //[0]: true/false [1]:給 status_change_action 的狀態碼 [2]: 錯誤細節
  let str_status = []

  switch (String(status).substring(0, 1)) {
    case "2": str_status.push(true); str_status.push(row); break;
    case "4": str_status.push(false); str_status.push(String(status)); str_status.push(detail); break;
    case "5":
      if (localStorage.getItem('user_name') === '管理者admin') {
        str_status.push(false); str_status.push("600"); str_status.push(detail);
      } else {
        str_status.push(false); str_status.push(String(status)); str_status.push('404');
      }
      break;
    default:
  }
  return str_status
}

function status_change_action(status, detail) {
  let SCAstatus = false;

  switch (status.substring(0, 1)) {
    case "4":
      // 進入 refresh 環節
      if (status === '401') {
        const apiUrl = api_url + "/api/Auth/Login";

        const formData = new FormData();
        formData.append("refreshToken", localStorage.getItem('refreshToken'));

        fetch(apiUrl,
          {
            method: "POST",
            headers: {
              "Authorization": localStorage.getItem('accessToken')
            },
            body: formData // 将数据正确序列化为 JSON 字符串
          })
          .then(response => response.json())
          .then(data => {
            let arr_status = data_change_status(data.statusCode, data.row, data.detail)
            //console.log(arr_status)
            if (arr_status[0]) {
              localStorage.setItem('accessToken', arr_status[1].accessToken); //將Token寫入browser
              localStorage.setItem('refreshToken', arr_status[1].refreshToken);
              SCAstatus = true;
              return SCAstatus
            } else {
              if (arr_status[1] === '401') {
                Swal.fire({
                  title: "驗證失敗",
                  text: "登入過期等等問題，請重登.",
                  icon: "error",
                  buttons: ["回登入畫面!", true]
                }, function (answer) {
                  setTimeout(funLogout(), 5000)
                })
              } else {
                status_change_action(arr_status[1], arr_status[2])
              }
            }
          })
          .catch(error => {
            console.error('Error:', error);
          });
        return SCAstatus
      }else {
        Swal.fire({
          title: "頁面資料錯誤",
          text: detail,
          icon: "error"
        })
      }
      break;
    case "5":
      window.location.href = '404'
      break;
    case "6":
      Swal.fire({
        title: "【系統管理者 系統錯誤】",
        text: detail,
        icon: "error"
      })
    break;
    default:
  }
}

function formatDate(dateString) {
  if (dateString && dateString.length === 8) {
    const year = dateString.substr(0, 4);
    const month = dateString.substr(4, 2);
    const day = dateString.substr(6, 2);
    return `${year}/${month}/${day}`;
  } else {
    return dateString; // 如果日期格式不正確，直接返回原始值
  }
}

function funLogout() {
  localStorage.clear();
  window.location.href = '/';
}

export { data_change_status, status_change_action, formatDate, funLogout};